import React, {Fragment} from "react";
import humanizeString from "string-humanize";
import {CardBody, CardText, CardTitle} from "reactstrap";

const PortForwardingCard = ({data, headers}) => {
  return (
    <CardBody>
      {headers?.map((eachTitle, titleIndex) => {
        return (
          <Fragment key={titleIndex}>
            <CardTitle tag="h4">{`${humanizeString(eachTitle)} :`}</CardTitle>
            <CardText>{data[eachTitle]}</CardText>
          </Fragment>
        );
      })}
    </CardBody>
  );
};

export default PortForwardingCard;
